import { Routes } from '@angular/router';
import { AuthGuard } from '@utils/guards/auth.guard';

export const fundsRoutes: Routes = [
  {
    path: 'funds',
    loadComponent: () =>
      import('./funds.component').then((c) => c.FundsComponent),
    canActivate: [AuthGuard],
  },
];
